<template>
    <div class="d-flex flex-column align-items-center text-center">
        <b-form-group
                id="secondWorks-form"
                label="🥈При необходимости можно расписать сопутствующие работы"
                label-class="label-class"
                class="w-75 mt-5"
        >
            <AppTextarea
                    id="textarea"
                    v-model="secondWorks"
                    placeholder="Например: Уборка мусора, вязка арматурных каркасов, разгрузка материалов"
            ></AppTextarea>
        </b-form-group>
    </div>
</template>

<script>
export default {
    name: "StepFive",
    computed: {
        secondWorks: {
            get() {
                return this.$store.state.shiftReport.secondWorks;
            },
            set(v) {
                this.$store.commit(`shiftReport_setSecondWorks`, v);
                this.$store.dispatch(`shiftReport_updateCache`);
            }
        }
    },
    mounted() {
        this.$emit(`can-continue`, {
            value: true
        });
    }
}
</script>

<style scoped>

#textarea::placeholder {
  color: #6c757d;
  opacity: 0.3;
}

</style>